import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {Card, Edition} from '../../core/entities/entities';
import {CardQuery, CardService} from '../../services/card.service';
import {LanguageService} from '../../services/language.service';
import {WarehouseService} from '../../services/warehouse.service';
import {ToastrService} from 'ngx-toastr';
import {ComponentBase} from '../../core/entities/component-base';
import {TypeaheadMatch} from 'ngx-bootstrap';
import {ActivatedRoute, Router} from '@angular/router';
import {EditionService, EditiontQuery} from '../../services/edition.service';
import {CardConditionService} from '../../services/card-condition.service';
import {Observable} from 'rxjs/Observable';
import * as Rx from 'rxjs/Rx';
import {PriceRuleDetailDTO, PriceRuleService} from '../../services/price-rule.service';
import {isNullOrUndefined} from 'util';
import {NgForm} from '@angular/forms';

@Component({
  selector: 'app-price-rule-add',
  templateUrl: './price-rule-add.component.html',
  styleUrls: ['./price-rule-add.component.css']
})
export class PriceRuleAddComponent  extends ComponentBase implements OnInit {
/*
{
  "altered": null,
  "conditionId": [],
  "cardId": null,
  "editionId": [],
  "foil": null,
  "hot": null,
  "inked": null,
  "languageId": [],
  "price": 100,
  "rarityId": [],
  "signed": null,
  "stamped": null
}*/

  @ViewChild('rapidForm') rapidForm: NgForm;

  cardMeta: string[] = [ ...this.cardTypes, 'minRule', 'maxRule'/*, 'hot'*/];




  comment: string;

  public cardConditionDisabled = false;

  card_search: CardQuery = {autocomplete_edition: '', autocomplete_card_name: '', autocomplete_language: this.defaultLanguageId};
  cards: Observable<Card[]>;
  card: Card;

  enableRule= {
    cardId: {
      not: ['editionId', 'hot',  'rarityId']
    },
    editionId: {
      not: ['cardId']
    },

    productName: {
      not: ['cardId'],
      disabled: ['cardId']
    },

    languageSearchId: {
      need: ['productName'],
      not: ['cardId'],
      disabled: ['cardId']
    },

    hot: {
      not: ['cardId']
    },
    rarityId: {
      not: ['cardId']
    },
    maxPrice: {
      need: ['maxRule']
    },
    maxRule: {
      need: ['minRule']
    }

  };

  isDisabled(field: string) {
    const rule = this.enableRule[field];
    const me = this;

    // FIXME SANTIAGO HO DISABILITATO PERCHE VIENE SELEZZIONATO QUINDI NON HA IL SENSO PER FARE REQUIRED
    if (field == 'maxRule') {
      if ( !me.item  || !me.item['minRule'] || 'false' == me.item['minRule'] + '' ) {
        return true;
      }
    }

    if (field == 'maxPrice') {
      if ( !me.item  || !me.item['maxRule'] || 'false' == me.item['maxRule'] + '' ||  'false' == me.item['minRule'] + '') {
        return true;
      }
    }



    let disabilitato = false;

     Object.keys(me.item).forEach(key => {
       if (me.item[key] == 'null') {
         me.item[key] = null;
       }
     });

    if (rule) {
      if (rule.need) {
        // se trovo null obbligatorie
        disabilitato = rule.need.some(key =>
          {
            return (Array.isArray(me.item[key]) && me.item[key] && me.item[key].length == 0 ) || (!Array.isArray(me.item[key]) && isNullOrUndefined(me.item[key]))  ;
          }
        );
      }

      if (!disabilitato && rule.not) {
        // se trovo !null non richieste
        disabilitato = rule.not.some(key =>
          {
            return  (Array.isArray(me.item[key]) && me.item[key] && me.item[key].length > 0 ) || ( !Array.isArray(me.item[key]) && !isNullOrUndefined(me.item[key]));
          }
        );
      }

      if (!disabilitato && rule.disabled) {
        // se trovo il campo abilitato
        disabilitato = rule.disabled.some(key =>
          {
            return !me.isDisabled(key);
          }
        );
      }
    }

    if (disabilitato) {
      me.item[field] = null;
      // tslint:disable-next-line:max-line-length
    } else if ( (Array.isArray(me.item[field]) && me.item[field] && me.item[field].length == 0 ) || (!Array.isArray(me.item[field]) && isNullOrUndefined(me.item[field]))) {
      me.item[field] = me.item[field];
    }

    return disabilitato;


  }

  selectCard(event: TypeaheadMatch) {
    console.log(event);
    if (event && event.item) {
      this.card = event.item;
      this.card_search.autocomplete_card_name = this.card.name;
      this.card_search.autocomplete_edition = this.card.edition;
      this.item.cardId = this.card.id;
      this.eraseEdition();

    }
  }

  eraseCard() {
    this.card_search.autocomplete_edition = '';
    this.item.cardId = null;
    this.item['cardData'] = null;

    this.item.cardId = null;
    this.card = null;

    this.cardConditionDisabled = false;
  }

  selectEdition(event: TypeaheadMatch) {
    if ( event && event.item ) {
      this.edition = event.item;
      this.selectedEditions.push(event.item);
      this.edition = null;
    }
  }



  private _editionMap: {[ key: string ]: Edition} = {};

  getEdition(id: any): Edition{
    if (!this._editionMap[id]){

      this._editionMap[id] = this.selectedEditions.find( ed => ed.id == id);
    }

  return this._editionMap[id];
  }

  removeEdition( id: any){
    this.selectedEditions = this.selectedEditions.filter( ed => ed.id != id);
    this._editionMap[id] = undefined;
    this.item.editionId = this.item.editionId.filter( ed => ed != id);
  }

  eraseEdition() {
    this.edition_search.edition = null;
    this.item.editionId = null;
    this.edition = null;
    this.selectedEditions = [];
  }
  selectedEditions: Edition[] = [];
  edition_search: EditiontQuery = {edition_name: '', type: 0, wh_id: null};
  editions: Rx.Observable<Edition[]>;
  edition: Edition;


  get warehouses() {
    return Observable.create((observer: any) => {
      this._warehouseService.dataChange.subscribe(ret => observer.next(ret.filter(w => !w.refill)));
    });
  }

  get languages() {
    return this._languageService.dataChange;
  }

  get conditions() {
    return this._cardConditionService.dataChange;
  }

  item = new PriceRuleDetailDTO();

  constructor(protected _priceRuleService: PriceRuleService,
              protected _route: ActivatedRoute,
              protected _languageService: LanguageService,
              protected _warehouseService: WarehouseService,
              protected _cardConditionService: CardConditionService,
              protected _cardService: CardService,
              protected _editionServ: EditionService,
              protected _router: Router,
              protected _toastrService: ToastrService) {
    super();
  }

  ngOnInit() {

    this.cardTypes.forEach( m => {
      if (m === 'stamped' || m === 'inked') {
        this.item[m] = null;
      } else {
        this.item[m] = false;
      }
    });
    this.item.holo = 0;
    const me = this;
    this.cards = Rx.Observable.create((observer: any) => {
      observer.next(this.card_search);
    }).debounceTime(150)
      .distinctUntilChanged()
      .switchMap((term) => {
        return this._cardService.search({...term, categoryId: this.categoryId, brandId: this.brandId});
      });

    this.editions = Rx.Observable.create((observer: any) => {
      observer.next(this.edition_search);
    }).debounceTime(150)
      .distinctUntilChanged()
      .switchMap((term) => {
        return this._editionServ.search({...term, brandId: this.brandId });
      });

    this.item.categoryId = this.categoryId;
    this.item.brandId = this.brandId;

    // Object Keys default keys init new rule SE PUO CONVERTIRE A ONLY MODELBASE COMPONENT
    Object.keys(me.item).forEach(key => {
      me.item['minRule'] = true;
      me.item['maxRule'] = false;
      me.item['languageId'] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
      me.item['conditionId'] = [2];

    });

  }

  clearFilters() {
    this.eraseCard();
    this.eraseEdition();
    this.edition_search.edition = null;
  }



  add() {

    this.item.editionId = this.selectedEditions.map( edition => edition.id);
    this.spinnerService.show();

    this._priceRuleService.insert(this.item).subscribe(ret => {this._toastrService.success('Eseguito Correttamente!') ; this._router.navigateByUrl('/home/price_rules'); this.spinnerService.hide(); });
  }

  checkHotDisabled(m: string): boolean {

    //if(m == "hot" && this.card != null) return true;

    return false;

  }

  onChecked(meta: string, checked: string) {
    console.log(checked);
    if (meta === 'maxRule') {
      if (checked === 'true' && this.item.price) {
        this.item.maxPrice = this.item.price;
      } if (checked !== 'true') {
        this.item.maxPrice = undefined;
      }
    } else if (meta === 'minRule') {
      if (checked !== 'true') {
        this.item.maxPrice = undefined;
        this.item['maxRule'] = false;
      }
    }
  }

  @HostListener('keydown.enter', ['$event'])
  onEnterKey(event: KeyboardEvent) {
    event.preventDefault();
    this.handleUpdate();
  }

  handleUpdate() {
    if (!this.currentProductStruct || !this.currentProductStruct.id || !this.rapidForm.form.valid) {
      return;
    }
    this.confirmAndUpdate();
  }

  confirmAndUpdate() {
    const confirmed = confirm('Sicuro di voler creare la regola?');
    if (confirmed) {
      this.add();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/conf/price-rule-add/price-rule-add.component.ts